module.exports = __webpack_public_path__ + "img/link-6.dbd13ab9.png";